/**
 * Images live on a plain CDN with no transforms, so full-size files (1.5 MB+) were
 * being downloaded for slots a few hundred pixels wide. These helpers route them
 * through a resizing image proxy that returns compressed WebP at the needed width.
 */
const PROXY = 'https://wsrv.nl/'

export const IMAGE_PROXY_ORIGIN = 'https://wsrv.nl'

export function optimizedImage(src: string, width: number, quality = 78): string {
  return `${PROXY}?url=${encodeURIComponent(src)}&w=${width}&output=webp&q=${quality}&af`
}

export function optimizedSrcSet(src: string, widths: number[], quality = 78): string {
  return widths.map((width) => `${optimizedImage(src, width, quality)} ${width}w`).join(', ')
}

export const HERO_WIDTHS = [360, 420, 576, 768]
export const HERO_SIZES = '(max-width: 640px) 92vw, 576px'

export const OFFER_WIDTHS = [360, 448, 640, 896]
export const OFFER_SIZES = '(max-width: 640px) 88vw, 448px'

export const BONUS_WIDTHS = [320, 420, 640]
export const BONUS_SIZES = '(max-width: 640px) 88vw, 320px'
